export default __webpack_public_path__ + "static/media/arbitrum_logo.ec8e5080.svg";